<form
[formGroup]="form"
class="animated fadeIn fast"
[class.mt-10]="anyAlert() || loading"
appBlockCopyPaste
>
  <app-loading *ngIf="loading"></app-loading>
  <app-alert *ngIf="capslockOn && !loading" [alert]="capslock"></app-alert>
  <app-alert *ngIf="error" [alert]="error"></app-alert>
  <app-alert
    *ngIf="
      helpers.invalidControl(form.get('ruc')) &&
      !form.get('ruc').errors.required
    "
    [alert]="invalidRuc"
  ></app-alert>
  <div *ngIf="!loading" class="animated fadeIn fast">
    <div class="row">
      <div class="col-lg-12">
        <h4 class="subtitle primary">Ingresa los datos de la empresa</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div
          class="form-group"
          [class.has-error]="helpers.invalidControl(form.get('ruc'))"
        >
          <label for="ruc" class="label-form label-create-form"
            >RUC de la Empresa</label
          >
          <input
            type="text"
            formControlName="ruc"
            class="form-control"
            maxlength="11"
            mask="0*"
          />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('ruc'))"
          >
            <span *ngIf="form.get('ruc').errors.required">{{
              constants.validations.required.message
            }}</span>
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div
          class="form-group"
          [class.has-error]="helpers.invalidControl(form.get('name'))"
        >
          <label for="name" class="label-form label-create-form"
            >Nombre / Razón social</label
          >
          <input type="text" formControlName="name" class="form-control" />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('name'))"
          >
            <span *ngIf="form.get('name').errors.required">{{
              constants.validations.required.message
            }}</span>
            <span *ngIf="form.get('name').errors.pattern">{{
              constants.validations.alphabetic.message
            }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div
          class="form-group"
          [class.has-error]="helpers.invalidControl(form.get('area'))"
        >
          <label for="area" class="label-form label-create-form">Rubro</label>
          <input
            type="text"
            maxlength="100"
            formControlName="area"
            class="form-control"
          />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('area'))"
          >
            <span *ngIf="form.get('area').errors.required">{{
              constants.validations.required.message
            }}</span>
            <span *ngIf="form.get('area').errors.pattern">{{
              constants.validations.alphabetic.message
            }}</span>
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div
          class="form-group"
          [class.has-error]="helpers.invalidControl(form.get('address'))"
        >
          <label for="address" class="label-form label-create-form"
            >Dirección</label
          >
          <input
            type="text"
            maxlength="100"
            formControlName="address"
            class="form-control"
          />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('address'))"
          >
            <span *ngIf="form.get('address').errors.required">{{
              constants.validations.required.message
            }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div
          class="form-group"
          [class.has-error]="helpers.invalidControl(form.get('email'))"
        >
          <label for="email" class="label-form label-create-form">Correo</label>
          <input type="text" formControlName="email" maxlength="60" class="form-control" />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('email'))"
          >
            <span *ngIf="form.get('email').errors.required">{{
              constants.validations.required.message
            }}</span>
            <span *ngIf="form.get('email').errors.pattern">{{
              constants.validations.email.message
            }}</span>
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div
          class="form-group"
          [class.has-error]="helpers.invalidControl(form.get('phone'))"
        >
          <label class="label-form label-create-form" for="phone"
            >Teléfono</label
          >
          <input
            type="text"
            class="form-control"
            formControlName="phone"
            prefix="+51 9 "
            mask="0*"
            [validation]="true"
            maxlength="14"
            
            
          />
          <span
            class="help-block invalid-feedback"
            *ngIf="helpers.invalidControl(form.get('phone'))"
          >
            <span *ngIf="form.get('phone').errors.required">{{
              constants.validations.required.message
            }}</span>
            <span *ngIf="form.get('phone').errors.minlength">{{
              constants.validations.invalidPhone.message
            }}</span>
            <span
              *ngIf="
                !form.get('phone').errors.required &&
                !form.get('phone').errors.minlength
              "
              >{{ constants.validations.invalidPhoneFormat.message }}</span
            >
          </span>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!loading" class="row text-center">
    <button
      [disabled]="form.invalid || loading || !_account.validCompany"
      (click)="continue()"
      class="button-continue button-find-label"
    >
      Continuar
    </button>
  </div>
  <div *ngIf="!loading" class="row text-center">
    <a class="primary green-link" [routerLink]="['/login/company']">Volver ></a>
  </div>
</form>
